// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResults-cls1__fd047394531953b7c9a9{/*!*/}.AutoCompleteResults-cls2__b0a31624e1608d6b29f5{margin-right:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResults-cls1__fd047394531953b7c9a9",
	"cls2": "AutoCompleteResults-cls2__b0a31624e1608d6b29f5 AutoCompleteResults-cls1__fd047394531953b7c9a9"
};
export default ___CSS_LOADER_EXPORT___;
